/* eslint
  object-shorthand: 0,
  func-names: 0,
  prefer-arrow-callback: 0,
  --------
  Marionette and jQuery rely on the "this" keyword to access properties and methods.
*/

((Weglot, Backbone, Marionette) => {
  if (typeof Weglot === 'undefined') return;

  Weglot.initialize({
    api_key: window.weglotData.api_key,
  });

  const fieldsToTranslate = [
    'changeEmailErrorMsg',
    'changeDateErrorMsg',
    'confirmFieldErrorMsg',
    'fieldNumberNumMinError',
    'fieldNumberNumMaxError',
    'fieldNumberIncrementBy',
    'formErrorsCorrectErrors',
    'validateRequiredField',
    'honeypotHoneypotError',
    'fieldsMarkedRequired',
  ];

  // Cache the forms that are loaded
  const forms = [];

  // Previous language
  let previousLanguage = Weglot.getCurrentLang();

  // Translate errors from global form settings. Yes, I know there are multiple sets of these, but
  // we're not making any distinguishing differences between them.
  const valuesToTranslate = fieldsToTranslate.map((field) => (
    // eslint-disable-next-line no-undef
    { t: 1, w: form.settings[field] }
  ));

  function languageChangedCallback() {
    const currentLanguage = Weglot.getCurrentLang();
    if (currentLanguage === previousLanguage) return;

    previousLanguage = currentLanguage;

    Weglot.translate({
      words: valuesToTranslate,
      languageTo: currentLanguage,
    }).then((translatedData) => {
      forms.forEach((form) => {
        const settings = form.get('settings');
        fieldsToTranslate.forEach((field, index) => {
          settings[field] = translatedData[index];
        });
      });
    });
  }
  languageChangedCallback();
  Weglot.on('languageChanged', languageChangedCallback);

  const lastTranslate = {};

  // Create a new object for translating form errors
  const formTranslationHandler = Marionette.Object.extend({
    initialize: function () {
      const appChannel = Backbone.Radio.channel('app');
      const submitChannel = Backbone.Radio.channel('submit');
      // Add the forms to the cache
      this.listenTo(appChannel, 'forms:loaded', this.addForm);
      this.listenTo(submitChannel, 'change:model', this.modifySubmitButton);
    },

    addForm: function (formCollection) {
      formCollection.forEach((form) => {
        forms.push(form);
      });
    },

    modifySubmitButton: function (model) {
      const currentLanguage = Weglot.getCurrentLang();

      if (lastTranslate[model.cid] === currentLanguage) return;
      lastTranslate[model.cid] = currentLanguage;

      const originalMessage = model.get('label');

      Weglot.translate({
        words: [{ t: 1, w: originalMessage }],
        languageTo: currentLanguage,
      }).then((translatedData) => {
        model.set('label', translatedData[0]);
      });
    },
  });

  jQuery(document).ready(function () {
    // eslint-disable-next-line
    new formTranslationHandler();
  });
})(window.Weglot, window.Backbone, window.Marionette);
